import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { queryClient } from "./queries/queryClient";
import { routeTree } from "./routeTree.gen";

export interface RouterContext {
    queryClient: QueryClient;
}

export const router = createRouter({
    routeTree,
    context: {
        queryClient,
    },
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

declare module "@tanstack/router-core" {
    interface Register {
        router: typeof router;
    }
}
